import type { KambiGroup } from '@mobi/api-types/kambi'
import { E_SOCCER_GROUP_ID, reformatSportsName } from '../reformatSportsName'
import { simpleFetchWithLogging } from '../simpleFetchWithLogging'

export async function getEventGroupsFromRoot(): Promise<GetEventGroupsFromRootResponse> {
  const eSoccer = await getEventGroupByGroupId(E_SOCCER_GROUP_ID).catch(() => null)

  const response = await simpleFetchWithLogging<GetEventGroupsFromRootResponse>(
    `${window._kc.apiOfferingBaseUrl}group?lang=en_AU&market=AU`
  )
  const groups = formatESportsGroupNames(response.group.groups)
  const groupsWithESoccer = eSoccer ? [...groups, eSoccer.group] : groups

  return {
    ...response,
    group: {
      ...response.group,
      groups: groupsWithESoccer,
    },
  }
}

export async function getEventGroupByGroupId(groupId: number) {
  const res = await simpleFetchWithLogging<{ group: KambiGroup }>(
    `${window._kc.apiOfferingBaseUrl}group/${groupId}?lang=en_AU&market=AU`
  )
  const renamedGroups = formatESportsGroupNames([res.group])

  return {
    group: renamedGroups[0],
  }
}

export async function getGroupHighlights() {
  const response = await simpleFetchWithLogging<{ groups: KambiGroup[] }>(
    `${window._kc.apiOfferingBaseUrl}group/highlight?lang=en_AU&market=AU`
  )
  const renamedGroups = formatESportsGroupNames(response.groups)

  if (renamedGroups) return { groups: renamedGroups }

  return response
}

// =============
// Local Helpers
// =============

const formatESportsGroupNames = (groups: KambiGroup[]) => {
  return groups.map(group => {
    return { ...group, name: reformatSportsName(group.name) }
  })
}

// =====
// Types
// =====

type GetEventGroupsFromRootResponse = {
  group: { boCount: number; eventCount: number; groups: KambiGroup[]; id: 1 }
}
